module.exports = __webpack_public_path__ + "static/media/like.c590b4da.svg";